<template>
  <Drawer
    v-model="isShow"
    :title="title"
    width="80"
    :mask-closable="true"
    @on-visible-change="statusChange"
  >
    <div class="content-box">
      <div class="content scroll-430 scroll-y-430">
        <div v-if="orderDetails" class="order-block">
          <div class="block-top">
            <span>订单编号：{{ orderDetails.insOrderId }}</span>
            <span>下单时间：{{ orderDetails.payTime }}</span>
            <span>{{ channelTypeList[orderDetails.channelType] }}</span>
            <span>{{ payTypeStrList[orderDetails.payType] }}</span>
          </div>
          <div class="block-bottom">
            <div v-for="(value, key) in infoObj" :key="key" class="info-block">
              <span>{{ value.num }}</span>
              <span>{{ value.name }}</span>
            </div>
          </div>
        </div>
        <div class="class-block">
          <div class="class-line">
            <span>所在班级：</span>
            <div class="btn-line smart-scroll">
              <div
                v-for="(item, index) in classList"
                :id="'classbtn-' + index"
                :key="index"
                class="line-btn-box"
              >
                <Button
                  :icon="
                    item.studentSts && item.studentSts === 1 ? 'ios-pin' : ''
                  "
                  :type="selectClass === index ? 'primary' : 'default'"
                  @click="handleClickBtn(index)"
                >{{ item.classroomName }}</Button>
              </div>
            </div>
            <div v-if="classList.length > 1" class="next-btn">
              <Button
                type="text"
                icon="ios-arrow-forward"
                @click="handleScrollBtn"
              >
              </Button>
            </div>
          </div>
          <div class="search-line">
            <Form
              ref="searchForm"
              :model="formValidate"
              label-position="right"
              :label-width="100"
              class="search-list-430"
            >
              <Row class="relative" type="flex" flex="end">
                <FormItem label="考勤时间">
                  <div class="date-line">
                    <DatePicker
                      v-model="begin"
                      :options="beginDateOption"
                      type="date"
                      placeholder="请选择开始时间"
                      @on-change="getThisDate($event, 'classDateStart')"
                    ></DatePicker>
                    <span>至</span>
                    <DatePicker
                      v-model="end"
                      :options="endDateOption"
                      type="date"
                      placeholder="请选择结束时间"
                      @on-change="getThisDate($event, 'classDateEnd')"
                    ></DatePicker>
                  </div>
                </FormItem>
                <FormItem prop="signStateShow" label="考勤状态">
                  <Select
                    v-model="formValidate.signStateShow"
                    placeholder="请选择考勤状态"
                    style="width: 140px"
                  >
                    <Option
                      v-for="(item, index) in signStatusList"
                      :key="index"
                      :value="item.status"
                    >{{ item.name }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="结算状态">
                  <Select
                    v-model="formValidate.tallyStsShow"
                    placeholder="请选择结算状态"
                    style="width: 140px"
                  >
                    <Option
                      v-for="(item, index) in tallyStsList"
                      :key="index"
                      :value="item.status"
                    >{{ item.name }}</Option>
                  </Select>
                </FormItem>
                <Button
                  class="search-430"
                  type="primary"
                  @click="handleSearch"
                >查询</Button>
              </Row>
            </Form>
          </div>
          <div class="table-block">
            <Table
              border
              :loading="loading"
              :columns="askLeaveColumn"
              :data="classDataList"
            >
              <template slot="classroomName" slot-scope="{ row }">
                <span v-if="row.classroomId">{{ row.classroomName }}</span>
                <span v-else>--</span>
              </template>
              <template slot="spellClassTime" slot-scope="{ row }">
                <span v-if="row.classroomId">{{ row.spellClassTime }}（第{{ row.classNo }}节）</span>
                <span v-else>--</span>
              </template>
              <template slot="signState" slot-scope="{ row }">
                <!-- <span v-if="row.classroomId">{{
                  row.signState === 4 ? '请假' : signStatusObj[row.signState]
                }}{{
                  row.tallySts === 5 && row.signState !== 4
                    ? '（已退款）'
                    : ''
                }}</span> -->
                <span v-if="row.classroomId">{{
                  row.signState === 4 ? '请假' : signStatusObj[row.signState]
                }}{{ row | showHasRefundText }}</span>
                <span v-else>--</span>
                <span v-if="row.daycareDetailId&&row.daycareDetailId!=='0'" style="color:red">（节次已转入其他班级）</span>
              </template>
              <template slot="tallySts" slot-scope="{ row }">
                <span v-if="row.classroomId">{{
                  tallyStatusObj[row.tallySts]
                }}</span>
                <span v-else>--</span>

              </template>
            </Table>
            <Page
              :total="total"
              show-total
              show-elevator
              :current="pageNum"
              class="page-right"
              @on-change="handlePageChange"
              @on-page-size-change="handlePageSize"
            ></Page>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <Button
          style="margin-right: 8px"
          size="large"
          @click="close"
        >取消</Button>
      </div>
    </div>
  </Drawer>
</template>
<script>
import {
  tableColumnsWidth,
  key,
  slot
} from '@/assets/js/resetTableStyle';
import eduCenter from '@/request/eduCenter/index.js';
import { payTypeStrList } from '@/utils/dictionary.js';
import { signStatusList, changeDictionaries, tallyStsList, hasRefundTallyStsList } from '@/utils/dictionary.js';
export default {
  filters: {
    showHasRefundText(row) {
      const tag = hasRefundTallyStsList.includes(row.tallySts);
      return tag && row.signState !== 4 ? '（已退款）' : '';
    }
  },
  props: {
    orderId: {
      type: String,
      default: ''
    },
    classroomId: {
      type: String,
      default: ''
    },
    stuId: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '查看订单考勤'
    }
  },
  data() {
    return {
      isShow: false,
      infoObj: {
        'classroomTotal': {
          name: '总课时',
          num: 0
        },
        'awaitNumber': {
          name: '待结算',
          num: 0
        },
        'underwayNumber': {
          name: '可结算',
          num: 0
        },
        'finishedNumber': {
          name: '已结算',
          num: 0
        },
        'refundedNumber': {
          name: '已退款',
          num: 0
        },
        'leaveRefundedNumber': {
          name: '请假可退款',
          num: 0
        }
      },
      classList: [],
      selectClass: 0,
      classColumn: [
        {
          title: '序号',
          key: 'orderNO'
        },
        {
          title: '班级名称',
          key: 'className'
        },
        {
          title: '班级ID',
          key: 'classId'
        }, {
          title: '考勤时间（时间）',
          key: 'attandanceTime'
        },
        {
          title: '考勤状态',
          key: 'daySignStatus'
        }, {
          title: '结算状态',
          key: 'settlementStatus'
        }
      ],
      askLeaveColumn: [
        key('序号', 'sort', tableColumnsWidth.type2),
        slot('班级名称', 'classroomName', tableColumnsWidth.type6),
        key('班级ID', 'classroomId', tableColumnsWidth.type6),
        slot('考勤时间（时间）', 'spellClassTime', tableColumnsWidth.type7),
        slot('考勤状态', 'signState', tableColumnsWidth.type6), // 0未开始 1未考勤 2签到 3签退 4请假 5缺席 6停课
        slot('结算状态', 'tallySts', tableColumnsWidth.type2) // 0未开始 1未考勤 2签到 3签退 4请假 5缺席 6停课
      ],
      signStatusObj: changeDictionaries(signStatusList),
      tallyStatusObj: changeDictionaries(tallyStsList),
      classDataList: [],
      orderDetails: null,
      channelTypeList: ['', 'APP', '微信小程序', 'H5', '管理后台'], // 1:APP 2：微信小程序 3：H5 4：管理后台
      payTypeStrList: [...payTypeStrList],
      formValidate: {
        signStateShow: -1,
        signState: null, // 考勤状态 : 1未考勤 2签到 3签退 4请假
        signTimeStart: null, // 考勤开始时间
        signTimeEnd: null, // 考勤结束时间
        tallyStsShow: -1,
        tallySts: null // 结算状态 1-已结算 2-可结算  5-已退款  8-请假可退款  3467-可结算
      },
      begin: null,
      end: null,
      signStatusList: [
        {
          status: -1,
          name: '请选择'
        }, {
          status: 1,
          name: '未签到'
        }, {
          status: 2,
          name: '已签到'
        }, {
          status: 3,
          name: '已签退'
        }, {
          status: 4,
          name: '请假'
        }, {
          status: 5,
          name: '缺勤'
        }
      ], // 考勤状态 : 1未考勤 2签到 3签退 4请假
      tallyStsList: [
        {
          status: -1,
          name: '请选择'
        }, {
          status: 1,
          name: '已结算'
        }, {
          status: 2,
          name: '可结算'
        }, {
          status: 5,
          name: '已退款'
        }, {
          status: 8,
          name: '请假可退款'
        }, {
          status: 3467,
          name: '待结算'
        }
      ], // 1-已结算 2-可结算  5-已退款  8-请假可退款  3467-待结算
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: false
    };
  },
  computed: {
    // 开始日期应该不能小于结束日期
    beginDateOption() {
      const that = this;
      return {
        disabledDate(date) {
          let status = true;
          // 如果有结束日期的话
          if (that.end) {
            status = date && date.valueOf() < (new Date(that.end).valueOf() + 86400000);
          }
          return !status;
        }
      };
    },
    // 开始日期应该不能小于结束日期
    endDateOption() {
      const that = this;
      return {
        disabledDate(date) {
          let status = true;
          // 如果有结束日期的话
          if (that.begin) {
            status = date && date.valueOf() > (new Date(that.begin).valueOf() - 86400000);
          }
          return !status;
        }
      };
    },
    activeClassroomId() {
      if (this.selectClass === 0) {
        return '';
      } else {
        return this.classList[this.selectClass].classroomId;
      }
    }
  },
  watch: {
    selectClass() {
      this.getAttendanceDetails();
    }
  },
  created() {
    // this.getClassList();
  },
  methods: {
    open() {
      this.orderDetails = null;
      this.getOrderDetails();
      this.getOrderClass();
      this.isShow = true;
      this.getAttendanceDetails();
    },
    close() {
      this.isShow = false;
    },
    statusChange(status) {
      if (!status) {
        this.resetInfo();
      }
    },
    resetInfo() {
      this.selectClass = 0;
      this.pageNum = 1;
      this.formValidate = {
        signStateShow: -1,
        signState: null, // 考勤状态 : 1未考勤 2签到 3签退 4请假
        signTimeStart: null, // 考勤开始时间
        signTimeEnd: null, // 考勤结束时间
        tallyStsShow: -1,
        tallySts: null // 结算状态 1-已结算 2-可结算  5-已退款  8-请假可退款  3467-可结算
      };
    },
    handleClickBtn(index) {
      const element = document.getElementById(`classbtn-${index}`);
      element.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      this.selectClass = index;
    },
    handleScrollBtn() {
      const nextOne = this.selectClass === (this.classList.length - 1) && this.selectClass !== 0 ? 0 : this.selectClass + 1;
      const element = document.getElementById(`classbtn-${nextOne}`);
      element.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      this.selectClass = nextOne;
    },
    // 获取考勤的订单信息
    async getOrderDetails() {
      const params = {
        orderId: this.orderId
      };
      const res = await eduCenter.getStudentsOrderStatisticsApi(params);
      if (res.status === 200) {
        this.orderDetails = res.message;
        Object.keys(this.infoObj).forEach(item => {
          this.infoObj[item].num = res.message[item];
        });
      }
    },
    async getOrderClass() {
      const params = {
        payOrderId: this.orderId
      };
      const res = await eduCenter.postClassroomReadingStudentApi(params);
      if (res.status === 200) {
        this.classList = res.message;
        this.classList.unshift({
          classroomName: '全部'
        });
      }
    },
    // 获取考勤明细
    async getAttendanceDetails() {
      if (!this.isShow) {
        return;
      }
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        stuId: this.stuId,
        payOrderId: this.orderId
      };
      if (this.activeClassroomId !== '') {
        params.classroomId = this.activeClassroomId;
      }
      const searchParams = Object.assign({}, params, this.formValidate);
      this.loading = true;
      const res = await eduCenter.getStudentAttendanceDetailsApi(searchParams);
      this.loading = false;
      if (res.status === 200) {
        this.classDataList = res.message.list.map((item, index) => {
          item.sort = index + 1;
          return item;
        });
        this.total = +res.message.total;
      }
    },
    getThisDate(date, name) {
      console.log(date, name, '=====');
      if (date) {
        this.formValidate[name] = name === 'begin' || name === 'classDateStart' ? `${date} 00:00:00` : `${date} 23:59:59`;
      } else {
        this.formValidate[name] = null;
      }
    },
    handleSearch() {
      this.formValidate.signStateShow === -1 ? this.formValidate.signState = null : this.formValidate.signState = this.formValidate.signStateShow;
      this.formValidate.tallyStsShow === -1 ? this.formValidate.tallySts = null : this.formValidate.tallySts = this.formValidate.tallyStsShow;
      this.pageNum = 1;
      this.getAttendanceDetails();
    },
    handlePageChange(page) {
      this.pageNum = page;
      this.getAttendanceDetails();
    },
    handlePageSize(pageSize) {
      this.pageSize = pageSize;
      this.pageNum === 1 && this.getAttendanceDetails();
    }
  }
};
</script>
<style lang="scss" scoped>
.smart-scroll {
  scrollbar-width: thin; //火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细
  &::-webkit-scrollbar {
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    width: 4px;
    height: 60px;
    background: rgba(0, 0, 0, 0.15);
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background: rgba(255, 255, 255, 0);
  }
}
/deep/.ivu-drawer-body {
  padding: 8px;
}
/deep/.search-list-430 .ivu-form-item {
  margin-bottom: 8px;
}
/deep/.search-list-430 .ivu-form-item-content {
  min-width: 150px;
}
/deep/.ivu-table td {
  height: 44px;
}
.content-box {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .content {
    flex: 1;
    width: 100%;
    padding: 8px;
    min-height: 1px;
    .order-block {
      border: 1px solid rgb(238, 239, 239);
      border-radius: 4px;
      .block-top {
        background: rgb(247, 248, 250);
        padding: 8px 16px;
        span + span {
          margin-left: 16px;
        }
        span {
          font-weight: bold;
        }
      }
      .block-bottom {
        padding: 8px 16px;
        display: flex;
        justify-content: center;
        .info-block {
          border-radius: 8px;
          background: rgb(242, 242, 242);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 8px;
          flex: 1;
          // span+span{
          //   margin-top: 16px;
          // }
          span:nth-of-type(1) {
            font-weight: bold;
            font-size: 24px;
          }
        }
        .info-block + .info-block {
          margin-left: 16px;
        }
      }
    }
    .class-block {
      border: 1px solid rgb(128, 128, 128);
      border-radius: 8px;
      margin-top: 8px;
      .class-line {
        padding: 8px 16px 0;
        border-bottom: 1px solid rgb(220, 220, 220);
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        .btn-line {
          flex: 1;
          overflow-x: scroll;
          padding-bottom: 8px;
          // height: 45px;
          // overflow-y: hidden;
          white-space: nowrap;
          .line-btn-box {
            display: inline-block;
          }
          .line-btn-box + .line-btn-box {
            margin-left: 24px;
          }
        }
      }
      .next-btn {
        padding-left: 8px;
      }
      .table-block {
        margin: 8px 0;
        padding: 0 16px;
      }
    }
  }
  .btn-box {
    margin-top: 8px;
    border-top: 1px solid #eee;
    width: 100%;
    height: 45px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    button {
      width: 100px;
    }
    button + button {
      margin-left: 16px;
    }
  }
}
.search-line {
  margin-top: 8px;
}
.date-line {
  display: flex;
  align-items: center;
  span {
    margin: 0 8px;
  }
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
</style>
